import { render, staticRenderFns } from "./InventorySearch.vue?vue&type=template&id=5dd4abc8&scoped=true&"
import script from "./InventorySearch.vue?vue&type=script&lang=js&"
export * from "./InventorySearch.vue?vue&type=script&lang=js&"
import style0 from "./InventorySearch.vue?vue&type=style&index=0&id=5dd4abc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4abc8",
  null
  
)

export default component.exports